export const backendUrl = (import.meta.env.VITE_NOTABLY_BACKEND_URL ||
  'http://localhost:3000') as string;

export default backendUrl;
